import type { DeepPartial } from '@luna/utils-ts';

import type { Payments } from './Payments';

export const HU: DeepPartial<Payments> = {
    bundleSigning: {
        enabled: false,
    },
};
